__turbopack_context__.v({
  "fontAwesomeIcon": "IntroIcons-module__iEeQ4G__fontAwesomeIcon",
  "intro": "IntroIcons-module__iEeQ4G__intro",
  "introContent": "IntroIcons-module__iEeQ4G__introContent",
  "introDescription": "IntroIcons-module__iEeQ4G__introDescription",
  "introIcon": "IntroIcons-module__iEeQ4G__introIcon",
  "introItem": "IntroIcons-module__iEeQ4G__introItem",
  "introLeftIcons": "IntroIcons-module__iEeQ4G__introLeftIcons",
  "introPaper": "IntroIcons-module__iEeQ4G__introPaper",
  "introStack": "IntroIcons-module__iEeQ4G__introStack",
  "introTitle": "IntroIcons-module__iEeQ4G__introTitle",
  "leftSide": "IntroIcons-module__iEeQ4G__leftSide",
});
